import React from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/css";
import {convertToMobileNumber} from "../../util/numberConvertor";
import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";

const RaikoMobileInputOutlined = (
    {
        labelText = "",
        placeHolder = "",
        value,
        setValue,
        className,
        disabled
    }) => {
    return (
        <RaikoMaterialOutlinedInput
            placeHolder={placeHolder}
            labelText={labelText}
            className={`
            ${
                css`
                  direction: ltr !important;
                  text-align: end !important;
                `
            } ${
                className
            }`}
            disabled={disabled}
            value={convertToMobileNumber(value)}
            onChange={({target}) => {
                const unConvertedValue = target.value.replaceAll(" ", "")
                const _value = convertToMobileNumber(unConvertedValue)
                setValue(_value.replaceAll(" ", ""))

            }}/>
    )
}

RaikoMobileInputOutlined.propTypes = {
    placeHolder: PropTypes.string,
    disabled: PropTypes.bool,
    labelText: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired
}

export default RaikoMobileInputOutlined